import { GetConnectedUserResponse } from '@lalalilo/api-interfaces'
import { VersionType } from '@lalalilo/enums'
import useLocalStorage from '@rehooks/local-storage'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { StringParam, useQueryParam } from 'use-query-params'
import {
  Trackers,
  useSharedTrackers,
} from '../../common/cookies/useSharedTrackers'
import { API_BASE_URI, TEACH_APP_URI } from '../../config'

export const useHasP2IAFullAccess = () => {
  const [token, setToken, removeToken] = useLocalStorage<string>('token')
  const [tokenParam, setTokenParam] = useQueryParam('token', StringParam)
  const [isP2IA, setIsP2IA] = useState<boolean | null>(null)
  const location = useLocation()
  const { trackers } = useSharedTrackers()

  useEffect(() => {
    if (tokenParam) {
      setToken(tokenParam)
      setTokenParam(undefined)
    }
  }, [tokenParam, setToken, setTokenParam])

  useEffect(() => {
    if (!token && !tokenParam) {
      window.location.assign(
        `${TEACH_APP_URI}/p2ia/login?redirect=${encodeURIComponent(
          `${window.location.origin}${location.pathname}?token=<token>`
        )}`
      )
    }
  }, [location, token, tokenParam])

  useEffect(() => {
    if (token) {
      hasP2IAFullVersion(token, trackers)
        .then(isP2IA => setIsP2IA(isP2IA))
        .catch(() => removeToken())
    }
  }, [token, removeToken, trackers])

  return isP2IA
}

const hasP2IAFullVersion = async (token: string, trackers: Trackers) => {
  const { data } = await axios.get<GetConnectedUserResponse>(
    `${API_BASE_URI}/user/me`,
    {
      headers: {
        authorization: `bearer ${token}`,
      },
    }
  )
  if (data.versionType === VersionType.P2IA_FULL_VERSION) {
    return true
  }
  trackers.event({
    category: 'P2IA access',
    action: 'Non P2IA user redirected',
    label: 'P2IA',
  })
  return false
}

export const useIsP2IAPage = (): boolean => {
  const location = useLocation()
  return (
    location?.pathname?.startsWith('/p2ia') ||
    location?.hostname?.startsWith('p2ia.') ||
    window?.location?.pathname?.startsWith('/p2ia') ||
    window?.location?.hostname?.startsWith('p2ia.')
  )
}
